// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2YldPu","container":"x2yruU","item":"_34CFAY","title":"_3ugaXX","img":"_3nmdGi"};